module.exports = __webpack_public_path__ + "static/live-engagement-86af6c7e4d1cadcfd26002b052e0ada5.jpg";